import type { FC } from "react";
import type { InputProps } from "../../DynamicInput";
import { SingleDpiaInput } from "../../shared/SingleDpiaInput";
import { inlineInputStateStyles } from "./InlineInputState";

export const Dpia: FC<InputProps<string>> = props => (
  <SingleDpiaInput inlineInputStateStyles={inlineInputStateStyles} {...props} />
);
